import { eramanBEApi } from "~/Services";
import { ModuleFields } from "~/Utils/drilldownData";

// Define the option type for select fields
export interface OptionType {
  label: string;
  value: string;
}

// Create a type for fields that may have async options
export type AsyncSelectField = ModuleFields & {
  loadOptions?: () => Promise<OptionType[]>;
};

// Function to fetch data and transform to options
const fetchDataAndTransform = async (url: string, searchParam: string = ""): Promise<OptionType[]> => {
  try {
    const res = await eramanBEApi.get(`${url}${searchParam ? `?search=${encodeURIComponent(searchParam)}` : ""}`);
    console.log("result of data", res.data);

    if (res?.data) {
      return res.data.data.map((item: any) => ({
        label: item.epcId,
        value: item.epcId,
        data: item,
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchEpcIdData = (searchParam: string = "") =>
  fetchDataAndTransform("/admin/epc/not-subscribed", searchParam);
